var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1918 38.5479C20.8384 40.484 16.7068 40.484 13.3534 38.5479L5.4192 33.9671C2.0658 32.031 2.56934e-05 28.453 2.53549e-05 24.5808L2.4554e-05 15.4192C2.42154e-05 11.547 2.0658 7.96898 5.4192 6.03289L13.3534 1.45207C16.7068 -0.484018 20.8384 -0.484019 24.1918 1.45207L32.126 6.03289C35.4794 7.96898 37.5452 11.547 37.5452 15.4192L37.5452 24.5808C37.5452 28.453 35.4794 32.031 32.126 33.9671L24.1918 38.5479Z",
    fill: "#1890FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45139 30.4473L15.3856 35.0281C17.4815 36.2381 20.0637 36.2381 22.1596 35.0281L30.0938 30.4473C32.1897 29.2372 33.4808 27.0009 33.4808 24.5808L33.4808 15.4192C33.4808 12.9991 32.1897 10.7628 30.0938 9.55275L22.1596 4.97193C20.0637 3.76187 17.4815 3.76187 15.3856 4.97193L7.45139 9.55275C5.35552 10.7628 4.0644 12.9991 4.06441 15.4192L4.06441 24.5808C4.06441 27.0009 5.35552 29.2372 7.45139 30.4473ZM13.3534 38.5479C16.7068 40.484 20.8384 40.484 24.1918 38.5479L32.126 33.9671C35.4794 32.031 37.5452 28.453 37.5452 24.5808L37.5452 15.4192C37.5452 11.547 35.4794 7.96898 32.126 6.03289L24.1918 1.45207C20.8384 -0.484015 16.7068 -0.484015 13.3534 1.45207L5.4192 6.03289C2.0658 7.96898 2.42154e-05 11.547 2.4554e-05 15.4192L2.53549e-05 24.5808C2.56934e-05 28.453 2.0658 32.031 5.4192 33.9671L13.3534 38.5479Z",
    fill: "#BAE7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5319 14.0474C27.3255 14.841 27.3255 16.1277 26.5319 16.9213L17.4999 25.9533C16.7063 26.7469 15.4196 26.7469 14.626 25.9533L11.0132 22.3405C10.2196 21.5469 10.2196 20.2602 11.0132 19.4665C11.8068 18.6729 13.0935 18.6729 13.8871 19.4665L16.0629 21.6423L23.6579 14.0474C24.4515 13.2537 25.7383 13.2537 26.5319 14.0474Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.922a1254e6bf7a49ee8b40cb751e59a4.svg";
export { ForwardRef as ReactComponent };